// create array of [flag='XX'], populate canvas with flags, each one with the corresponding array index as attribute, e.g.
// <div index='1' />
// when clicking or hovering the div flag, the corresponding index in the array will change to 'BR' or 'CN' for instance

const canvas = document.querySelector(".canvas");
const currentFlag = document.querySelector(".current .flag");
const linesInput = document.querySelector("[type=number]");
const selectBrush = document.querySelector("[name=brush]");
const selectPaint = document.querySelector("[name=paint]");
const copyButton = document.querySelector(".copy");
const resetButton = document.querySelector(".reset");
const textarea = document.querySelector("textarea");
const cyprusFlagSrc = require(`../static/assets/flags/CY.webp`);
const chinaFlagSrc = require(`../static/assets/flags/CN.webp`);
const nepalFlagSrc = require(`../static/assets/flags/NP.webp`);

const flagFileNames = [
  "AD.gif",
  "AE.gif",
  "AF.gif",
  "AFR.gif",
  "AG.gif",
  "AL.gif",
  "AM.gif",
  "AO.gif",
  "AR.gif",
  "AS.gif",
  "ASIA.gif",
  "AT.gif",
  "AU.gif",
  "AW.gif",
  "AZ.gif",
  "BA.gif",
  "BB.gif",
  "BD.gif",
  "BE.gif",
  "BF.gif",
  "BG.gif",
  "BH.gif",
  "BI.gif",
  "BJ.gif",
  "BM.gif",
  "BN.gif",
  "BO.gif",
  "BR.gif",
  "BS.gif",
  "BT.gif",
  "BW.gif",
  "BY.gif",
  "BZ.gif",
  "CA.gif",
  "CD.gif",
  "CF.gif",
  "CG.gif",
  "CH.gif",
  "CI.gif",
  "CK.gif",
  "CL.gif",
  "CM.gif",
  "CN.gif",
  "CO.gif",
  "CR.gif",
  "CU.gif",
  "CV.gif",
  "CY.gif",
  "CZ.gif",
  "DE.gif",
  "DJ.gif",
  "DK.gif",
  "DM.gif",
  "DO.gif",
  "DZ.gif",
  "EC.gif",
  "EE.gif",
  "EG.gif",
  "ENG.gif",
  "ER.gif",
  "ES.gif",
  "ET.gif",
  "EU.gif",
  "FI.gif",
  "FJ.gif",
  "FO.gif",
  "FR.gif",
  "GA.gif",
  "GB.gif",
  "GD.gif",
  "GE.gif",
  "GH.gif",
  "GL.gif",
  "GM.gif",
  "GN.gif",
  "GQ.gif",
  "GR.gif",
  "GT.gif",
  "GU.gif",
  "GW.gif",
  "GY.gif",
  "HK.gif",
  "HN.gif",
  "HR.gif",
  "HT.gif",
  "HU.gif",
  "ID.gif",
  "IE.gif",
  "IL.gif",
  "IN.gif",
  "IQ.gif",
  "IR.gif",
  "IS.gif",
  "IT.gif",
  "JM.gif",
  "JO.gif",
  "JP.gif",
  "KE.gif",
  "KG.gif",
  "KH.gif",
  "KM.gif",
  "KN.gif",
  "KR.gif",
  "KW.gif",
  "KY.gif",
  "KZ.gif",
  "LB.gif",
  "LC.gif",
  "LI.gif",
  "LK.gif",
  "LR.gif",
  "LS.gif",
  "LT.gif",
  "LU.gif",
  "LV.gif",
  "LY.gif",
  "MA.gif",
  "MC.gif",
  "MD.gif",
  "ME.gif",
  "MG.gif",
  "MK.gif",
  "ML.gif",
  "MM.gif",
  "MN.gif",
  "MO.gif",
  "MR.gif",
  "MT.gif",
  "MU.gif",
  "MV.gif",
  "MW.gif",
  "MX.gif",
  "MY.gif",
  "NA.gif",
  "NAM.gif",
  "NE.gif",
  "NG.gif",
  "NI.gif",
  "NL.gif",
  "NO.gif",
  "NP.gif",
  "NZ.gif",
  "OCE.gif",
  "OM.gif",
  "PA.gif",
  "PE.gif",
  "PG.gif",
  "PH.gif",
  "PK.gif",
  "PL.gif",
  "PR.gif",
  "PS.gif",
  "PT.gif",
  "PY.gif",
  "QA.gif",
  "RE.gif",
  "RO.gif",
  "RS.gif",
  "RU.gif",
  "RW.gif",
  "SA.gif",
  "SAM.gif",
  "SB.gif",
  "SC.gif",
  "SCT.gif",
  "SD.gif",
  "SE.gif",
  "SG.gif",
  "SI.gif",
  "SK.gif",
  "SL.gif",
  "SM.gif",
  "SN.gif",
  "SO.gif",
  "SR.gif",
  "SS.gif",
  "ST.gif",
  "SV.gif",
  "SY.gif",
  "SZ.gif",
  "TD.gif",
  "TG.gif",
  "TJ.gif",
  "TL.gif",
  "TM.gif",
  "TN.gif",
  "TO.gif",
  "TR.gif",
  "TT.gif",
  "TW.gif",
  "TZ.gif",
  "UA.gif",
  "UG.gif",
  "US.gif",
  "UY.gif",
  "UZ.gif",
  "VC.gif",
  "VE.gif",
  "VG.gif",
  "VI.gif",
  "VN.gif",
  "VU.gif",
  "WLS.gif",
  "WORLD.gif",
  "WS.gif",
  "XK.gif",
  "YE.gif",
  "YU.gif",
  "ZA.gif",
  "ZM.gif",
  "ZW.gif",
];

let canvasLines = 17;
let canvasHeight = canvasLines * 26;

let flagsArray = ["flag=CY", "flag=CN", "flag=CY"];
let brush = "CN";
let background = "CY";

function createFlag(flag, index) {
  const img = document.createElement("img");
  img.classList.add("flag");
  img.setAttribute(
    "src",
    `https://www.hltv.org/img/static/flags/30x20/${flag}.gif`
  );
  img.setAttribute("index", index);

  return img;
}

function updateTextArea() {
  textarea.innerText = flagsArray.join("");
}

function populateFlagsArray(flag, qty) {
  // if (cleanUpArray) flagsArray.length = 0;
  flagsArray.splice(0, Number.MAX_SAFE_INTEGER);

  for (let i = 0; i < qty; i++) {
    flagsArray.push(`[flag=${flag}]`);
  }
  updateTextArea();
  populateFlags();
  addImgEventHandler();
}

function changeBackground(flag, i) {
  flagsArray = flagsArray.map((f) => {
    if (f === `[flag=${background}]`) {
      return `[flag=${selectPaint.value}]`;
    }

    return f;
  });
  background = selectPaint.value;

  updateTextArea();
  populateFlags();
  addImgEventHandler();
}

function populateFlags() {
  canvas.innerHTML = "";
  flagsArray.forEach((txt, i) => {
    const flag = txt.split("=")[1].replace("]", "");
    const img = createFlag(flag, i);
    canvas.append(img);
  });
}

function populateSelect(selectElement) {
  flagFileNames.forEach((filename) => {
    const abbreviation = filename.split(".")[0];

    const option = document.createElement("option");
    option.value = abbreviation;
    option.innerText = abbreviation;

    selectElement.append(option);
  });
}

function addImgEventHandler() {
  const imgs = document.querySelectorAll(".flag");

  imgs.forEach((img) => {
    img.addEventListener("mouseenter", () => {
      const index = img.attributes.index.value;

      img.src = `https://www.hltv.org/img/static/flags/30x20/${brush}.gif`;
      flagsArray[index] = `[flag=${brush}]`;

      updateTextArea();
    });
  });
}

// Populate flags on canvas
populateFlagsArray(selectPaint.value, canvasHeight);

//set default current flag
currentFlag.src = `https://www.hltv.org/img/static/flags/30x20/${brush}.gif`;

// add event handlers

// POPULATE SELECT DROPDOWNS
populateSelect(selectBrush);
populateSelect(selectPaint);

linesInput.value = canvasLines;

selectBrush.onchange = (e) => {
  brush = e.target.value;
  console.log(e.target.value);
  currentFlag.src = `https://www.hltv.org/img/static/flags/30x20/${e.target.value}.gif`;
};

selectPaint.onchange = (e) => {
  changeBackground(selectPaint.value);
  // populateFlagsArray(e.target.value, canvasHeight);
};

// ADD EVENT LISTENERS TO WINDOW TO PAINT/STOP PAINTING

window.addEventListener("mousedown", () => {
  canvas.style.pointerEvents = "all";
});

window.addEventListener("mouseup", () => {
  canvas.style.pointerEvents = "none";
});

copyButton.onclick = async () => {
  await navigator.clipboard.writeText(flagsArray.join(""));
  alert("Text Copied");
};

resetButton.onclick = () => {
  populateFlagsArray(selectPaint.value, canvasHeight);
};

linesInput.onchange = (e) => {
  canvasHeight = Number(e.target.value) * 26;
  populateFlagsArray(selectPaint.value, canvasHeight);
};
